// src/components/HeroSection.jsx — ohapotato v2026.10.36
import React from 'react';

const STEPS = [
  { n:'1', label:'Pick ingredients', detail:"Choose what's in your fridge", icon:'🥦', xp:'+5 XP' },
  { n:'2', label:'Find recipes',     detail:'We match you to the best dishes', icon:'🔍', xp:'+10 XP' },
  { n:'3', label:'Start cooking',    detail:'Step-by-step with chef insights', icon:'🍳', xp:'+50 XP' },
];

export default function HeroSection() {
  return (
    <div className="hero-section">

      {/* ── Heading ── */}
      <h1 style={s.heading}>
        From fridge<br />
        to <span style={s.em}>fork.</span>
      </h1>
      <p style={s.sub}>
        Tell us what you've got. We'll find something worth cooking tonight.
      </p>

      {/* ── Steps ── */}
      <div style={s.stepsRow} className="hero-steps-row">
        {STEPS.map((step, i) => (
          <React.Fragment key={step.n}>
            <div style={s.step} className="hero-step-max">
              {/* top: number + xp */}
              <div style={s.stepTop}>
                <div style={s.stepNum}>{step.n}</div>
                <span className="xp-badge">{step.xp}</span>
              </div>
              {/* icon */}
              <div style={s.stepIconWrap}>
                <span style={s.stepIcon}>{step.icon}</span>
              </div>
              {/* text */}
              <p style={s.stepLabel}>{step.label}</p>
              <p style={s.stepDetail}>{step.detail}</p>
            </div>
            {i < 2 && <div style={s.connector} className="hero-connector"><div style={s.connectorLine} /></div>}
          </React.Fragment>
        ))}
      </div>

      <p style={s.hint}>Try: eggs · garlic · pasta · spinach</p>
    </div>
  );
}

const s = {
  heading: {
    fontFamily: 'var(--font-display)',
    fontSize: 'clamp(38px, 6vw, 66px)',
    fontWeight: '800', lineHeight: '0.98', letterSpacing: '-1px',
    color: 'var(--text-primary)', marginBottom: '18px',
    transition: 'color 0.25s ease',
  },
  em: { color: 'var(--accent-orange)' },
  sub: {
    fontFamily: 'var(--font-body)',
    fontSize: 'clamp(13px, 1.8vw, 15px)',
    color: 'var(--text-muted)', lineHeight: '1.6',
    maxWidth: '360px', margin: '0 auto 32px',
    fontWeight: '400',
  },

  // ── Step row ──────────────────────────────────────────
  stepsRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: '0',
    marginBottom: '20px',
    width: '100%',
  },

  // Each step card
  step: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    flex: '1',
    maxWidth: '160px',
    padding: '0 8px',
  },

  stepTop: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },

  stepNum: {
    width: '22px', height: '22px', borderRadius: '50%',
    background: 'var(--accent-orange)', color: '#fff',
    fontFamily: 'var(--font-body)', fontSize: '11px', fontWeight: '700',
    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
    boxShadow: '0 2px 6px rgba(196,88,26,0.30)',
  },

  stepIconWrap: {
    width: '52px', height: '52px',
    borderRadius: '16px',
    background: 'var(--bg-card)',
    border: '1px solid var(--border-base)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    boxShadow: 'var(--shadow-sm)',
    fontSize: '24px',
  },

  stepIcon: { lineHeight: '1' },

  stepLabel: {
    fontFamily: 'var(--font-display)',
    fontSize: '14px', fontWeight: '700',
    color: 'var(--text-primary)',
    margin: 0, lineHeight: '1.2', textAlign: 'center',
  },

  stepDetail: {
    fontFamily: 'var(--font-body)',
    fontSize: '12px', fontWeight: '400',
    color: 'var(--text-muted)',
    margin: 0, lineHeight: '1.4', textAlign: 'center',
  },

  // Connector between steps
  connector: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '38px',  // vertically aligns with icon centre
    flexShrink: 0,
    width: '28px',
  },
  connectorLine: {
    width: '100%', height: '1.5px',
    background: 'var(--border-base)',
  },

  hint: {
    fontFamily: 'var(--font-body)', fontSize: '12px',
    color: 'var(--text-muted)', fontStyle: 'italic', opacity: 0.75,
  },
};
